module.exports = __webpack_public_path__ + "media/images/grade/A-e9f6342a7fc72bde3e296c9cbb9c67db.svg";